import axios from 'axios'

const accountApi = axios.create({
  baseURL: import.meta.env.VITE_API_ACCOUNT_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

accountApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

export default accountApi
